import React from "react";
import Logo from "../../assets/images/pixl_logo_black 1.png";
import { toast } from "react-toast";
import axios from "axios";

function LeftPanel({ isVisible, toggleVisibility, selectedVersion,onClearChat  }) {

  const clearCoversation = async () => {
    try {
    
      const reqBody = {
        uuid: "",
        message: "",
        chatbot_type: selectedVersion.value,
        voice_input_file:  "string",
        language: "en",
        uploaded_input_file:  "string",
        uploaded_input_type:  "string",
        clear_conversation_history: true,
      };
      const response = await axios.post(
        global.chatBaseUrl + global.chatbot,
        reqBody
      );
      if (
        response?.data?.status === "success" &&
        response?.data?.detail?.code === 200
      ) {
          if(response?.data?.detail?.msg){
            const msg = response?.data?.detail?.msg
            toast.success(msg);
            onClearChat()
          }else{
            toast.error("Failed. Try again");
          }
        
      } else {
        toast.error("Failed. Try again");
      }
    } catch (error) {
      console.error("Error while making the chat API call:", error);
      toast.error("Failed. Try again");
    }
  };
  

const featureStatus = () => {
  toast.warn("Coming Soon.....");
}

  return (
    <div
      className={`${
        isVisible ? "" : "hide"
      } left__panel bg-white rounded p-1  `}
    >
      <div className="h-100 w-100 d-flex flex-column">
        <div className="align-items-center bg-white d-none d-lg-flex gap-2 pb-2 position-sticky pt-3 px-3 top-0 z-1">
          <img src={Logo} width={50} />
          <span className="font_18 fw_700">AI Chatbot</span>
        </div>
        <div className="d-lg-none d-flex justify-content-end pt-3 px-3 text_dark_gray w-100">
          <i className="fas fa-times font_20" onClick={toggleVisibility}></i>
        </div>
        <div className="h-100 overflow-auto px-3 scrollbar1">
          <div className="pt-4 px-1">
            <ul className="d-grid gap-3 gap-md-4 list-unstyled mb-0">
              <li className="cursor-pointer d-flex gap-3 px_hover_1 text_gray4 py-1" onClick={featureStatus}>
                <i className="fab fa-searchengin font_20"></i>
                <span>Explore</span>
              </li>
              <li className="cursor-pointer d-flex gap-3 px_hover_1 text_gray4 py-1" onClick={featureStatus}>
                <i className="far fa-comment-alt font_20"></i>
                <span>New Chat</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="align-items-center bg-white bottom-0 d-flex gap-2 pb-3 position-sticky pt-3 px-3 z-1">
          <div className="w-100">
            <div>
              <ul className="d-grid gap-3 gap-md-4 list-unstyled mb-0 px-1">
                <li className="cursor-pointer d-flex gap-3 px_hover_1 text_gray4 py-1" onClick={clearCoversation}>
                  <i className="far fa-trash-alt font_20"></i>
                  <span>Clear Conversations</span>
                </li>
                <li className="cursor-pointer d-flex gap-3 px_hover_1 text_gray4 py-1"  onClick={featureStatus}>
                  <i className="far fa-user-circle font_20"></i>
                  <span>My Account</span>
                </li>
                <li className="cursor-pointer d-flex gap-3 px_hover_1 text_gray4 py-1"  onClick={featureStatus}>
                  <i className="fas fa-external-link-alt font_20"></i>
                  <span>Updates & FAQ</span>
                </li>
              </ul>
            </div>
            {/* <div>
              <Button className="btn-close-white py-2 h-auto mt-4 rounded-3 w-100">
                Logout
              </Button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeftPanel;
